export function buildNewNoticesListTableHeaders({
  t,
  isOwn = false,
  includeModerationStatus = false,
}) {
  const nameClasses = isOwn ? "w-52" : "w-60";
  const priceClasses = isOwn ? "w-[6.8rem] text-right" : "w-[9rem] text-right";
  const descriptionClasses = isOwn ? "w-56" : "w-72";

  const headers = [
    {
      value: "image",
      label: t("page.catalog.image"),
      thClass: "w-24",
      tdClass: "max-w-[7rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "name",
      text: t("page.catalog.name"),
      thClass: nameClasses,
      tdClass: "name",
      disabled: true,
    },
    {
      value: "description",
      text: t("page.cart.description"),
      thClass: descriptionClasses,
      tdClass: "description",
      disabled: true,
    },
    {
      value: "quantity",
      text: t("page.fleaMarket.quantity"),
      thClass: "w-14 text-right",
      tdClass: "max-w-[3rem] min-w-[3rem] text-right",
      disabled: true,
    },
    {
      value: "price",
      text: t("page.fleaMarket.pricePiece"),
      thClass: priceClasses,
      tdClass: "price",
    },
    {
      value: "priceGeneral",
      text: t("page.fleaMarket.priceGeneral"),
      thClass: priceClasses,
      tdClass: "price",
    },
    {
      value: "status",
      text: t("page.fleaMarket.status"),
      thClass: "w-[7.7rem]",
      tdClass: "max-w-[7.7rem] min-w-[7.7rem]",
    },
  ];

  if (includeModerationStatus) {
    headers.push({
      value: "modStatus",
      text: t("page.fleaMarket.moderationStatus"),
      thClass: "w-[7.7rem]",
      tdClass: "max-w-[7.7rem] min-w-[7.7rem]",
    });
  }

  return headers;
}
